const $ = require('jquery');

const navItem = (isActive, navIndex, sliderIndex) =>
  `<li
    data-nav="${navIndex}"
    data-slider="${sliderIndex}"
    class="mammouth_slider__nav_item ${isActive ? 'active' : ''}"></li>`;

const timerTime = 10000;

class Slider {
  constructor() {
    this.sliders = [];
  }

  removeActiveClasses(slider) {
    $(slider)
      .children('.mammouth_slider__item.active')
      .removeClass('active');
    $(slider)
      .children('.mammouth_slider__nav')
      .children('.mammouth_slider__nav_item')
      .removeClass('active');
  }

  onNavClick(nav, timerTimeLocal) {
    const sliderIndex = nav.dataset.slider;
    const navIndex = nav.dataset.nav;
    const slider = this.sliders[sliderIndex].domElement;
    const currentSlider = $(slider)
      .children()
      .eq(navIndex);

    if ($(currentSlider).hasClass('with-excerpt')) {
      $(slider)
        .children('.mammouth_slider__nav')
        .addClass('bottom');
    } else {
      $(slider)
        .children('.mammouth_slider__nav')
        .removeClass('bottom');
    }
    this.removeActiveClasses(slider);
    if (!$(nav).hasClass('active')) {
      $(nav).addClass('active');
      $(slider)
        .children()
        .eq(navIndex)
        .addClass('active');

      const sliderColor = $(slider).children('.mammouth_slider__item.active')[0]
        .dataset.color;
      $(slider)
        .children('.mammouth_slider__nav')
        .removeClass('primary')
        .removeClass('secondary')
        .removeClass('tertiary')
        .addClass(sliderColor);
    }
    clearTimeout(this.sliders[sliderIndex].timer);

    this.sliders[sliderIndex].timer = setTimeout(() => {
      this.nextSlide(sliderIndex);
    }, timerTimeLocal);
  }

  drawNav() {
    this.sliders.forEach((slider, sliderIndex) => {
      let extraClass = '';
      if (
        $(slider.domElement)
          .children('.mammouth_slider__item.active')
          .hasClass('with-excerpt')
      ) {
        extraClass = ' bottom';
      }
      const sliderColor = $(slider.domElement).children(
        '.mammouth_slider__item.active',
      )[0].dataset.color;
      const navContainer = $(
        `<ul class="mammouth_slider__nav ${sliderColor}${extraClass}"></ul>`,
      );
      for (let navIndex = 0; navIndex < slider.slideCount; navIndex += 1) {
        const newNavItem = $(navItem(navIndex === 0, navIndex, sliderIndex));
        navContainer.append(newNavItem);
        newNavItem.click(e => this.onNavClick(e.currentTarget, timerTime * 3));
      }
      $(slider.domElement).append(navContainer);
    });
  }

  nextSlide(sliderIndex) {
    const slider = this.sliders[sliderIndex];
    if (slider) {
      if (slider.timer) {
        clearTimeout(slider.timer);
      }
      const index =
        slider.current < slider.slideCount - 1 ? slider.current + 1 : 0;
      slider.current = index;
      const nav = $(slider.domElement)
        .children('.mammouth_slider__nav')
        .children('.mammouth_slider__nav_item')[index];
      this.onNavClick(nav, timerTime);
    }
  }

  init() {
    this.sliders = [];
    $('.mammouth__slider').each((index, domElement) => {
      const slideCount = $(domElement).children('.mammouth_slider__item')
        .length;
      if (slideCount > 1) {
        const tempSlider = {
          domElement,
          index,
          slideCount,
          current: 0,
          timer: setTimeout(() => {
            this.nextSlide(index);
          }, timerTime),
        };
        this.sliders.push(tempSlider);
        this.drawNav();
      }
    });
  }
}

export default (() => new Slider())();
